import React, { useState, useEffect } from "react";
import CustomBanner from "../Components/CustomBanner/CustomBanner";
import Images from "../Constants/Images";
import { useTranslation } from "react-i18next";
import Colors from "../Constants/Color";
import ScrollAnimation from "react-animate-on-scroll";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useSelector } from "react-redux";
import axios from "axios";
const bannerdata = [
  {
    Name: "Experience the ",
    NameTwo: "Ultimate Getaway",
    Title: "We offer more than just a place to stay.",
    Bannerimg: Images.StaywithUs,
  },
];
const sliderdata = [
  {
    Images: Images.Toronto3,
    Interior: "Quebec, Canada",
    Hospitality: "5 Bedrooms | 16+ Guests",
    amountConverted: 346.93,
    route: "https://reservations.kozestays.com/property/HQPOY9JIINB45JE6",
  },
  {
    Images: Images.Toronto2,
    Interior: "Toronto, Canada",
    Hospitality: "1 Bedroom | 2 Guests",
    amountConverted: 106.41,
    route:
      "https://www.airbnb.ca/rooms/1216762083205282829?guests=1&adults=1&s=67&unique_share_id=490e45b6-f321-47e8-b38d-9202e1bb3e9c&source_impression_id=p3_1725564865_P3vFuqLKAD0MM-6_",
  },
  {
    Images: Images.Toronto1,
    Interior: "Black Creek, British Columbia",
    Hospitality: "2 bedrooms | 8 Guests",
    amountConverted: 197.96,
    route: "https://reservations.kozestays.com/property/HRYGI3UZNN151B37",
  },
  {
    Images: Images.Toronto,
    Interior: "Dubai, United Arab Emirates",
    Hospitality: "3 bedrooms | 6 Guests",
    amountConverted: 541,
    route: "https://reservations.kozestays.com/property/HQMD5O2UKQONAMX",
  },
];

const kozeChaletsSliderData = [
  {
    Images: Images.Toronto3,
    Interior: "Laurentians, Canada",
    Hospitality: "5 Bedrooms | 16+ Guests",
    amountConverted: 346.93,
    route: "https://reservations.kozechalets.ca/property/HQPOY9JIINB45JE6",
  },
];
const StaywithUs = ({ slidesToRows = 1 }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [slideshow, setslideshow] = useState(4);
  const hostName = window.location.hostname;

  useEffect(() => {
    function handleResize() {
      if (window.innerWidth < 700) {
        setslideshow(1);
      } else if (window.innerWidth >= 700 && window.innerWidth < 1280) {
        setslideshow(3);
      } else {
        setslideshow(4);
      }
    }
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const settings = {
    dots: false,
    rows: slidesToRows,
    infinite: true,
    speed: 900,
    slidesToShow: slideshow,
    autoplay: false,
    pauseOnHover: false,
    autoplaySpeed: 2000,
    beforeChange: (next) => {
      setActiveIndex(next);
    },
  };
  const { t } = useTranslation();
  const language = useSelector((state) => state.language);
  const handleviewStays = () => {
    if (language === "English (ca)") {
      window.location.href =
      hostName.includes("kozechalets")
          ? "https://reservations.kozechalets.ca/search?period=daily&duration=1&guests[adults]=1"
          : "https://reservations.kozestays.com/search?period=daily&duration=1&guests[adults]=1";
    } else {
      window.location.href =
      hostName.includes("kozechalets")
          ? "https://reservations.kozechalets.ca/search?period=daily&duration=1&guests[adults]=1/?lang=fr"
          : "https://reservations.kozestays.com/search?period=daily&duration=1&guests[adults]=1/?lang=fr";
    }
  };
  const handlelanguage = () => {
    if (language === "English (ca)") {
      window.location.href =  hostName.includes("kozechalets")
          ?  "https://reservations.kozechalets.ca/" : "https://reservations.kozestays.com/";
    } else {
      window.location.href =  hostName.includes("kozechalets")
          ?  "https://reservations.kozechalets.ca/?lang=fr" : "https://reservations.kozestays.com/";
    }
  };
  const currency = useSelector((state) => state.currency);
  const [rate, setRate] = useState(null);
  const currencies = {
    "USD ($)": "USD",
    "CAD ($)": "CAD",
    "Pound(₤)": "GBP",
    "Peso($)": "MXN",
    "Euro(€)": "EUR",
    "UAE(د.إ)": "AED",
  };
  useEffect(() => {
    const fetchExchangeRate = async () => {
      try {
        const response = await axios.get(
          `https://api.exchangerate-api.com/v4/latest/USD`
        );
        const currencyCode = currencies[currency];
        if (response.data.rates[currencyCode]) {
          setRate(response.data.rates[currencyCode]);
        } else {
          console.error(`Exchange rate for ${currencyCode} not found`);
        }
      } catch (error) {
        console.error("Error fetching exchange rate:", error);
      }
    };
    if (currency) {
      fetchExchangeRate();
    }
  }, [currency]);
  const convertPrices = (basePrice) => {
    return rate !== null ? (basePrice * rate).toFixed(0) : basePrice;
  };
  const handelStawidth = (item) => {
    window.open(item.route, "_blank");
  };
  return (
    <div style={{ backgroundColor: Colors.lightgoladn }} className="About_us">
      <CustomBanner bannerdata={bannerdata} />
      <div className="bg-[#E0C9AA] py-10 marker_slider">
        <div className=" text-center font-48 cinzel my-2  mt-12 max-[1279px]:my-1 capitalize">
          <ScrollAnimation animateIn="bounceInLeft">
            {t("Featured Stays")}
          </ScrollAnimation>
        </div>
        <div
          className={`container  publishing ${
            hostName.includes("kozechalets") && "KozeChalets_Remove_Background"
          }`}
        >
          <ScrollAnimation animateIn="none">
            {hostName.includes("kozechalets")? (
              <div
                style={{ display: "flex", justifyContent: "center" }}
                className="Laurentians_slider"
              >
                <div style={{}} className="">
                  {kozeChaletsSliderData.map((item, index) => (
                    <div
                      key={index}
                      className={`slide ${
                        index === activeIndex ? "active-slide" : ""
                      }`}
                      style={{ position: "relative" }}
                    >
                      {" "}
                      <ScrollAnimation animateIn="none">
                        <div
                          className="zoon_uot cursor-pointer"
                          style={{ borderRadius: "13px" }}
                          onClick={() => handelStawidth(item)}
                        >
                          <img
                            className="Montreal zoom_in"
                            src={item.Images}
                            style={{ width: "100%" }}
                            alt={item.Laurentians}
                          />
                          <div
                            className="bg-[#D9D9D9] absolute top-0 right-0 p-2"
                            style={{ borderRadius: "0px 13px" }}
                          >
                            <div
                              className="Optima"
                              style={{ fontSize: "15px", lineHeight: "15px" }}
                            >
                              {currency === "CAD ($)" ? (
                                <>
                                  {" "}
                                  $ {convertPrices(item.amountConverted)}{" "}
                                  CAD/night
                                </>
                              ) : (
                                <>
                                  {" "}
                                  {currency}{" "}
                                  {convertPrices(item.amountConverted)}
                                </>
                              )}
                            </div>
                            <div
                              className="Optima text-center"
                              style={{ fontSize: "10px", lineHeight: "15px" }}
                            >
                              {t("Avg rate")}
                            </div>
                          </div>
                        </div>
                        <div
                          className=" font-30 Optima mt-3 cursor-pointer capitalize"
                          onClick={() => handelStawidth(item)}
                        >
                          {t(item.Interior)}
                        </div>
                        <p
                          className=" Optima collapse_txte font-24 cursor-pointer capitalize"
                          onClick={() => handelStawidth(item)}
                        >
                          {t(item.Hospitality)}
                        </p>
                      </ScrollAnimation>
                    </div>
                  ))}
                </div>
              </div>
            ) : (
              <div className="Laurentians_slider">
                <Slider {...settings}>
                  {sliderdata.map((item, index) => (
                    <div
                      key={index}
                      className={`slide ${
                        index === activeIndex ? "active-slide" : ""
                      }`}
                      style={{ position: "relative" }}
                    >
                      {" "}
                      <ScrollAnimation animateIn="none">
                        <div
                          className="zoon_uot cursor-pointer"
                          style={{ borderRadius: "13px" }}
                          onClick={() => handelStawidth(item)}
                        >
                          <img
                            className="Montreal zoom_in"
                            src={item.Images}
                            style={{ width: "100%" }}
                            alt={item.Laurentians}
                          />
                          <div
                            className="bg-[#D9D9D9] absolute top-0 right-0 p-2"
                            style={{ borderRadius: "0px 13px" }}
                          >
                            <div
                              className="Optima"
                              style={{ fontSize: "15px", lineHeight: "15px" }}
                            >
                              {currency === "CAD ($)" ? (
                                <>
                                  {" "}
                                  $ {convertPrices(item.amountConverted)}{" "}
                                  CAD/night
                                </>
                              ) : (
                                <>
                                  {" "}
                                  {currency}{" "}
                                  {convertPrices(item.amountConverted)}
                                </>
                              )}
                            </div>
                            <div
                              className="Optima text-center"
                              style={{ fontSize: "10px", lineHeight: "15px" }}
                            >
                              {t("Avg rate")}
                            </div>
                          </div>
                        </div>
                        <div
                          className=" font-30 Optima mt-3 cursor-pointer capitalize"
                          onClick={() => handelStawidth(item)}
                        >
                          {t(item.Interior)}
                        </div>
                        <p
                          className=" Optima collapse_txte font-24 cursor-pointer capitalize"
                          onClick={() => handelStawidth(item)}
                        >
                          {t(item.Hospitality)}
                        </p>
                      </ScrollAnimation>
                    </div>
                  ))}
                </Slider>
              </div>
            )}
          </ScrollAnimation>
          <ScrollAnimation animateIn="none" className="text-center pt-16">
            <button
              onClick={handleviewStays}
              style={{ backgroundColor: "black", color: "white" }}
              className="text-black rounded-full py-2 px-7 Optima capitalize  font-[700]  font-24  white_class "
            >
              {t("View all Stays")}
            </button>
          </ScrollAnimation>
        </div>
      </div>
      <div
        style={{ backgroundColor: "#1B1C1C" }}
        className="pt-12 home_away py-10 text-white"
      >
        <div className=" text-center font-48 cinzel my-2  mt-12 max-[1279px]:my-1 capitalize ">
          <ScrollAnimation animateIn="bounceInLeft">
            {t("Why Choose KŌZĒ?")}
          </ScrollAnimation>
        </div>
        <div className="container">
          <div className="mt-10 overflow-hidden">
            <div className="scroll-item w-full md:w-1/2 lg:w-1/3 px-2 py-5">
              <div className="flex flex-col md:flex-row gap-8 Here_center">
                <div className="w-full md:w-1/2">
                  <ScrollAnimation animateIn="bounceInLeft">
                    <img
                      src={Images.StaywithUs3}
                      className="object-cover rounded-[10px]  max-[1279px]:rounded-br-[5%] "
                    />
                  </ScrollAnimation>
                </div>
                <div className="w-full md:w-1/2 mt-4">
                  <ScrollAnimation animateIn="bounceInRight">
                    <div className=" text-left font-48 cinzel my-2  max-[1279px]:my-1 capitalize">
                      {t("Unmatched Comfort")}
                    </div>
                    <p className="text-left Optima collapse_txte font-24">
                      {t(
                        "Every KŌZĒ property is thoughtfully designed with your"
                      )}
                      <br />
                      <span className="showbr"></span>
                      {t("comfort in mind. From luxurious bedding to fully")}
                      <br />
                      <span className="showbr"></span>
                      {t(
                        "equipped kitchens and cozy living spaces, we ensure that"
                      )}
                      <br />
                      <span className="showbr"></span>
                      {t("all the comforts of home are at your fingertips.")}
                      <br />
                      <span className="showbr"></span>
                    </p>
                  </ScrollAnimation>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style={{ backgroundColor: Colors.lightgoladn }} className=" py-10">
        <div className="container">
          <div className=" overflow-hidden">
            <div className="scroll-item w-full md:w-1/2 lg:w-1/3 px-2 py-5">
              <div className="flex flex-col md:flex-row gap-8 Here_center">
                <div className="w-full md:w-1/2 mt-5 text-black">
                  <ScrollAnimation animateIn="bounceInLeft">
                    <div className=" text-left font-48 cinzel my-2  max-[1279px]:my-1 capitalize">
                      {t("Stunning Locations")}
                    </div>
                    <p className="text-left Optima collapse_txte font-24">
                      {t(
                        "Our properties offer breathtaking views, serene surroundings, and"
                      )}
                      <br />
                      <span className="showbr"></span>
                      {t(
                        "easy access to local attractions. Whether you are seeking a"
                      )}
                      <br />
                      <span className="showbr"></span>
                      {t(
                        "peaceful retreat or an adventure-filled escape, KŌZĒ has the"
                      )}
                      <br />
                      <span className="showbr"></span>
                      {t("perfect location for you.")}
                      <br />
                      <span className="showbr"></span>
                    </p>
                  </ScrollAnimation>
                </div>
                <div className="w-full md:w-1/2">
                  <ScrollAnimation animateIn="bounceInRight">
                    <img
                      src={Images.StaywithUs2}
                      className="object-cover rounded-[10px]  max-[1279px]:rounded-br-[5%] "
                    />
                  </ScrollAnimation>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        style={{ backgroundColor: "#1B1C1C" }}
        className=" home_away py-10 text-white"
      >
        <div className="container">
          <div className=" overflow-hidden">
            <div className="scroll-item w-full md:w-1/2 lg:w-1/3 px-2 py-5">
              <div className="flex flex-col md:flex-row gap-8 Here_center">
                <div className="w-full md:w-1/2">
                  <ScrollAnimation animateIn="bounceInLeft">
                    <img
                      src={Images.StaywithUs1}
                      className="object-cover rounded-[10px]  max-[1279px]:rounded-br-[5%] "
                    />
                  </ScrollAnimation>
                </div>
                <div className="w-full md:w-1/2 mt-4">
                  <ScrollAnimation animateIn="bounceInRight">
                    <div className=" text-left font-48 cinzel my-2  max-[1279px]:my-1 capitalize">
                      {t("Seamless Stays")}
                    </div>
                    <p className="text-left Optima collapse_txte font-24">
                      {t(
                        "We believe in making your stay as hassle-free as possible."
                      )}
                      <br />
                      <span className="showbr"></span>
                      {t("With keyless entry, easy check-ins, and responsive")}
                      <br />
                      <span className="showbr"></span>
                      {t(
                        "customer service, your experience with KŌZĒ is designed"
                      )}
                      <br />
                      <span className="showbr"></span>
                      {t("to be smooth and enjoyable from start to finish.")}
                      <br />
                      <span className="showbr"></span>
                    </p>
                  </ScrollAnimation>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-[#E0C9AA] py-10 hidden">
        <div className=" text-center font-75 font-semibold cinzel my-2 mb-10  max-[1279px]:my-1 text-black capitalize">
          <ScrollAnimation animateIn="bounceInLeft">
            {t("What You will Love")}
          </ScrollAnimation>
        </div>
        <div className="container">
          <div className=" overflow-hidden">
            <div className="scroll-item w-full md:w-1/2 lg:w-1/3 px-2 py-5">
              <div className="flex flex-col md:flex-row gap-8 ">
                <div className="w-full md:w-1/2 text-center ">
                  <ScrollAnimation animateIn="none">
                    <img src={Images.premium3} className="m-auto" />
                    <div className=" text-center font-48 cinzel my-2  max-[1279px]:my-1 mt-10 capitalize">
                      {t("Luxurious Amenities")}
                    </div>
                    <p className="text-center Optima collapse_txte font-24">
                      {t("Enjoy premium amenities such as hot tubs,")}
                      <br />
                      <span className="showbr"></span>
                      {t("fireplaces, and outdoor spaces that make your stay")}
                      <br />
                      <span className="showbr"></span>
                      {t("special.")}
                    </p>
                  </ScrollAnimation>
                </div>
                <div className="w-full md:w-1/2 text-center ">
                  <img src={Images.premium2} className="m-auto" />
                  <div className=" text-center font-48 cinzel my-2  max-[1279px]:my-1 mt-10 capitalize">
                    {t("Personal Guides")}
                  </div>
                  <p className="text-center Optima collapse_txte font-24">
                    {t("Get local tips and recommendations directly from")}
                    <br />
                    <span className="showbr"></span>
                    {t("our team to make the most of your stay.")}
                    <br />
                    <span className="showbr"></span>
                  </p>
                </div>
                <div className="w-full md:w-1/2 text-center ">
                  <ScrollAnimation animateIn="none">
                    <img src={Images.premium4} className="m-auto" />
                    <div className=" text-center font-48 cinzel my-2  max-[1279px]:my-1 mt-10 capitalize">
                      {t("Flexible Booking")}
                    </div>
                    <p className="text-center Optima collapse_txte font-24">
                      {t("Whether you are planning a weekend getaway or a")}
                      <br />
                      <span className="showbr"></span>
                      {t("longer stay, our flexible booking options cater to")}
                      <br />
                      <span className="showbr"></span>
                      {t("your needs.")}
                    </p>
                  </ScrollAnimation>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className=" home_away py-10 text-black bg-[#E0C9AA] ">
        <div className="container">
          <div className=" overflow-hidden">
            <div className="scroll-item w-full md:w-1/2 lg:w-1/3 px-2 py-5">
              <div className="flex flex-col md:flex-row gap-8 Here_center">
                <div className="w-full md:w-1/2 mt-4">
                  <ScrollAnimation animateIn="bounceInRight">
                    <div className=" text-left font-48 cinzel my-2  max-[1279px]:my-1 capitalize">
                      {t("Explore Our Properties")}
                    </div>
                    <p className="text-left Optima collapse_txte font-24">
                      {t(
                        "Discover the diverse range of properties KŌZĒ has to"
                      )}
                      <br />
                      <span className="showbr"></span>
                      {t(
                        "offer, each with its own unique charm and character."
                      )}
                      <br />
                      <span className="showbr"></span>
                      {t(
                        "From cozy cabins to modern units, explore our listings to"
                      )}
                      <br />
                      <span className="showbr"></span>
                      {t("find your perfect gateway.")}
                    </p>
                    <ScrollAnimation
                      animateIn="bounceInRight"
                      className="text-left pt-8"
                    >
                      <button
                        onClick={handlelanguage}
                        style={{ backgroundColor: "black", color: "white" }}
                        className="text-white rounded-full py-2 px-7 Optima capitalize  font-[700]  font-24  white_class "
                      >
                        {t("Explore all Stays")}
                      </button>
                    </ScrollAnimation>
                  </ScrollAnimation>
                </div>
                <div className="w-full md:w-1/2">
                  <ScrollAnimation animateIn="bounceInLeft">
                    <img
                      src={Images.premium1}
                      className="object-cover rounded-[10px]  max-[1279px]:rounded-br-[5%] "
                    />
                  </ScrollAnimation>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default StaywithUs;
